<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fdajt1/tc-custom/9781612433790.jpg?1726273375268" alt="This image is the cover for the book Dessert Mash-Ups"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dessert Mash-Ups
      </h1>
      <p class="bookDescription body article font2">
        <b>Get creative with your baking with this collection of over fifty delicious dessert combinations.</b><br/><br/>One dessert is good. Two desserts are even better, but a doubly delicious mash-up of both into one all-new concoction is the best! This book’s fifty-two inspiring recipes bring a new level of creative fun to your baking, with treats guaranteed to wow everyone at the table, including:<br/><br/><b>• Cinnamon Rolls + Cookies</b><br/><br/><b>• Cheesecake + Cookie Dough Truffles</b><br/><br/><b>• Peanut Butter Cups + Brownies</b><br/><br/><b>• Apple Pie + Butter Cookies</b><br/><br/><b>• Carrot Cake + Coffee Cake</b><br/><br/><b>• Spice Cake + Blondies</b><br/><br/><b>• Brownies + Peppermint Candy</b><br/><br/><b>• and many more</b><br/><br/>With step-by-step instructions and gorgeous photos from Dorothy Kern, the mastermind behind the blog Crazy for Crust, it’s easy to create all the scrumptious, crowd-pleasing treats in <i>Dessert Mash-Ups</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Kern
      </h2>
      
      <p class="authorDescription body article"><B>Dorothy Kern </B>is the founder of CrazyforCrust.com, a popular food blog that reaches millions of people per month. Dorothy shares mostly sweet (but sometimes savory) recipes that are easy, fast, and accessible without any crazy ingredients. She is a go-to resource for all things desserts and loves the memories and happiness her recipes bring to kitchens around the world. When she&rsquo;s not in working, you can find Dorothy reading a book or binge-watching Bravo, often while online searching for sparkly shoes or earrings, or planning her next trip to anywhere and has dreams of living at the beach with her husband, teenage daughter, and precocious labradoodle-turned-second-child, Abby.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52e703b5